import { createFileRoute } from '@tanstack/react-router';

import { NotificationFormPage } from '@/features/notifications/NotificationFormPage';

export const Route = createFileRoute('/admin/_app/notifications/new')({
  component: () => <NotificationFormPage />,
});
